export class Menu {
  constructor() {
    const header = document.querySelector('.header');
    const globalNavBody = document.querySelector('.globalNav-body');
    const globalNavBg = document.querySelector('.globalNav-bg');

    document.addEventListener('DOMContentLoaded', function() {
      gsap.set(globalNavBody, {
        opacity: 0,
        display: "none"
      })
      gsap.set(globalNavBg, {
        opacity: "0",
      })

      function toggle() {
        if (globalNavBody.style.display === "none" || !globalNavBody.style.display) {
          gsap.to(globalNavBody, {
            duration: 0.3, //アニメーションの持続時間
            ease: "power2.out", //アニメーションのイージング
            opacity: 1,
            display: "block"
          });
          gsap.to(globalNavBg, {
            duration: 0.1,
            ease: "power2.out",
            opacity: "0.2",
          });
        } else { //メニューが表示されている場合は非表示
          gsap.to(globalNavBody, {
            duration: 0.1,
            ease: "power2.in",
            opacity: 0,
            display: "none"
          });
          gsap.to(globalNavBg, {
            duration: 0.1,
            ease: "power2.out",
            opacity: "0",
          });
        }
        header.classList.toggle('js-active');
        globalNavBody.classList.toggle('js-active');
        globalNavBg.classList.toggle('js-active');
      }

      document.querySelectorAll('.header-button-globalNav').forEach(function(element) {
        element.addEventListener('click', function(event) {
          event.preventDefault();
          toggle();
        });
      });

      globalNavBg.addEventListener('click', function(event) {
        event.preventDefault();
        toggle();
      });
    });
  }
}
